// Native
import { useState } from "react"

// Components
import { Button, HStack, ModalBody, ModalFooter, useToast } from "@chakra-ui/react"
import { Form, Modal } from "components"

// Config
import { API } from "config"

export default function Volume({ data, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({})
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState(false)
    const isEnabled = !!form?.height && !!form?.width && !!form?.length && !!form?.weight

    const onChange = ({ target }) => {
        const { name, value } = target
        setForm({...form, [name]: value })
        setErrors(null)
    }

    const handleSubmit = async () => {
        if(!isEnabled) return
        setLoading(true)

        try{
            await API.post(`/orders/${data.id}/volumes`, form)
            toast({ title: 'O volume foi adicionado', status: 'info'})
            onSuccess()
            setForm({})
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível adicionar o volume', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Modal loading={loading} size="lg" title="Adicionar volume para cotação" {...props}>
        <ModalBody fontSize="sm">
            Adicione corretamente as dimensões e pesos do volume para realizar a cotação automática.

            <Form.Form mt={4} onSubmit={handleSubmit}>
                
                <HStack>
                    <Form.Text
                        required
                        label="Altura:"
                        placeholder="Ex.: 1.23"
                        rightAddon="cm"
                        name="height"
                        value={form?.height}
                        error={errors?.height}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Form.Text
                        required
                        label="Largura:"
                        placeholder="Ex.: 1.23"
                        rightAddon="cm"
                        name="width"
                        value={form?.width}
                        error={errors?.width}
                        onChange={onChange}
                        isDisabled={loading}
                    />

                    <Form.Text
                        required
                        label="Comprimento:"
                        placeholder="Ex.: 1.23"
                        rightAddon="cm"
                        name="length"
                        value={form?.['length']}
                        error={errors?.['length']}
                        onChange={onChange}
                        isDisabled={loading}
                    />
                </HStack>

                <Form.Text
                    required
                    label="Peso:"
                    placeholder="Ex.: 1.23"
                    rightAddon="kg"
                    name="weight"
                    value={form?.weight}
                    error={errors?.weight}
                    onChange={onChange}
                    isDisabled={loading}
                />
            </Form.Form>
        </ModalBody>
        <ModalFooter>
            <Button w="100%" colorScheme="blue" children="Adicionar volume" isDisabled={!isEnabled} isLoading={loading}  onClick={handleSubmit}/>
        </ModalFooter>
    </Modal>
    )
}